module.exports = __webpack_public_path__ + "img/rectangle4.792cfdea.png";